import { Component } from "react"
import { ICoupon, ICouponType, IPageColor, IUserType } from "../typing"

import classnames from 'classnames';
import styles from '../index.module.less'
import { currencySymbolMap } from "@/constant";
import { freeShipTextMap, getLimit } from "../config/lang";
import { YBackGroundImage } from "@/utils/style-methods";
import { imgResource } from "../config/resource";
import { withReactTrack } from "@du/analytics-sdk";
import { createTrackConfig } from '../config/track-config'
import { isDuApp } from "@/utils/appUtils/getDevice";
import { formatMoney } from "@/utils";
interface ICouponProp {
    buttonName: string[]
    couponList: ICoupon[];
    changeUserType: any;
    // expireTime: string;
    renderUserType: IUserType;
    lang: string;
    region: string;
    userType: IUserType;
    pageColor: IPageColor;
    couponStatus: number;
}

interface ICouponState {
}

// todo: 代码有点多，应该可以优化
// 这里应该有很多异常情况
@withReactTrack({ createTrackConfig })
export default class ICouponList extends Component<ICouponProp, ICouponState>{
    constructor(props: ICouponProp) {
        super(props);
    }

    componentDidMount() {}
    
    changeRenderUserType(userType: IUserType) {
        const { buttonName } = this.props;
        let trackData = {}

        this.props.changeUserType(userType);
        if (userType === IUserType.buyer) {
            trackData = {
                name: buttonName[0],
                position: userType,
            }
        } else {
            trackData = {
                name: buttonName[1],
                position: userType,
            }
        }

        (this as any).$track('poizon_trade_rank_list_tab_click', trackData)
    }
    // 如果以后优惠券类型有新增的话请修正
    getPriceDom(deductionAmount: number, couponType: number) {
        const {lang, region} = this.props;

        switch(couponType) {
            case ICouponType.direct: 
                return (
                    <>
                        <span className={styles['coupon-discount-unit']}>{currencySymbolMap[region]}</span>
                        <span className={styles['coupon-discount-num']}>{formatMoney(deductionAmount)}</span>
                    </>
                );
            case ICouponType.shipping:
                return (
                    <span className={styles['coupon-discount-txt']}>{freeShipTextMap[lang]}</span>
                );
            default:
                return <span>此类型的优惠卷不支持</span>;
        }
    }

    getlimitAmountTxt(limitAmount: number, couponType: number): string {
        const {lang, region} = this.props

        return getLimit(lang, region, limitAmount, couponType)
    }
    
    // 顶部按钮区域，其实无逻辑耦合
    renderButtonArea() {
        const { userType, renderUserType, buttonName, pageColor } = this.props;

        return (
            <div className={styles['coupon-button-box']}>
                <div
                    className={styles['coupon-button']}
                    style={{
                        background: renderUserType === IUserType.buyer ? pageColor.couponBackColor : pageColor.couponUnActiveBackColor,
                        color: pageColor.couponButtonTxtColor,
                    }}
                    onClick={() => this.changeRenderUserType(IUserType.buyer)}>{buttonName[0]}</div>
                <div className={styles['coupon-button']}
                    style={{
                        background: renderUserType === IUserType.seller ? pageColor.couponBackColor : pageColor.couponUnActiveBackColor,
                        color: pageColor.couponButtonTxtColor,
                    }}
                    onClick={() => this.changeRenderUserType(IUserType.seller)}>{buttonName[1]}</div>
            </div>
        );
    }
    // 优惠券渲染模块
    renderConponList(userType: IUserType) {
        const { couponList, pageColor, lang } = this.props;
        // 限定渲染border的盒子
        const renderDashedBox = [0, 1, 3, 4];
        const aleadyGetCouponeImg = YBackGroundImage(imgResource["aleady-get-coupone"][lang], [{
            mode: 'resize',
            width: 73 * 3
        }])
        // 主体渲染逻辑
        const temp = couponList
                        .filter(coupon => +coupon.ownerType === userType)
                        .map(({deductionAmount, limitAmount, templateId, couponType}, index) => {
                            const limitTxt = this.getlimitAmountTxt(limitAmount, +couponType);
                            const priceTxt = this.getPriceDom(deductionAmount, +couponType);

                            return (
                                <div className={styles['coupon-box']} key={templateId + index}>
                                    <div
                                        className={classnames([{
                                            [styles['coupon-dash']]:renderDashedBox.indexOf(index) !== -1
                                        }])}
                                    >
                                        <div className={classnames([{
                                            [styles[`coupon-discount`]]: 1,
                                            [styles[`coupon-discount-${lang}`]]: 1,
                                        }])}>
                                           {priceTxt}
                                        </div>
                                        <div className={classnames([{
                                            [styles['coupon-text']]: 1,
                                            [styles[`coupon-text-${index}`]]: 1,
                                        }])}>{limitTxt}</div>
                                    </div>
                                </div>
                            );
                        });
        
                        
        return (
            <div
                className={styles['coupon-list-warpper']} 
                style={{
                    background: pageColor.couponBackColor,
                    color: pageColor.couponTxtColor,
                }}
            >
                {temp}
                {   
                    isDuApp() && (this.props.couponStatus === 1 || this.props.couponStatus === 6)
                    ? <div className={styles['coupon-aleady-get']} style={{...aleadyGetCouponeImg}}></div>
                    : ''
                }
            </div>
        );
    }
    
    render() {
        const { renderUserType, userType, couponList } = this.props;

        const buttonArea = this.renderButtonArea();
        const sellerRender = this.renderConponList(IUserType.seller);
        const buyerRender = this.renderConponList(IUserType.buyer);
        
        return (
            <div
                className={styles['coupon']}
                data-track-exposure={'poizon_trade_seller_coupon_exposure'}
                data-info={JSON.stringify(couponList)}
            >
                {/* 登陆为领取或者非登陆 */}
                { (userType === IUserType.all ) ? buttonArea : '' }
                {
                    renderUserType === IUserType.seller
                        ? sellerRender
                        : buyerRender
                }
            </div>
        );
    }
}
